module.exports = __webpack_public_path__ + "media/packs/images/flags/DK-af13771ef25b8bda265c0c8c7544584a.png";